// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"D5-z"};